import React, { useState } from "react";
import ModalForm from "../../components/ModalForm";
import CustomTextInput from "../../components/CustomTextInput";
import api from "../../api";

export default function CarModal({ isOpen, onClose, onCarAdded }) {
  const [name, setName] = useState("");
  const [licensePlate, setLicensePlate] = useState("");
  const [ownership, setOwnership] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isAdded, setIsAdded] = useState(false);

  const ownershipOptions = [
    { value: 1, label: "Aquila" },
    { value: 2, label: "Sixt" },
  ];

  const vehicleTypeOptions = [
    { value: 1, label: "Alta Gamma" },
    { value: 2, label: "Estándar" },
  ];

  const statusOptions = [
    { value: 1, label: "Disponible" },
    { value: 2, label: "En uso" },
    { value: 3, label: "En mantenimiento" },
  ];

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setFieldErrors({});

    const newVehicle = {
      name,
      licensePlate,
      ownership,
      vehicleType,
      status,
    };

    try {
      await api.vehicles.create(newVehicle);
      setIsAdded(true); // Marca como agregado
      onCarAdded(true); // Notifica al componente principal
      onClose(); // Cierra el modal después de guardar
      // Reinicia los valores del formulario
      setName("");
      setLicensePlate("");
      setOwnership("");
      setVehicleType("");
      setStatus("");
    } catch (error) {
      if (error.message) {
        setFieldErrors(error.message); // Ajustar esto según la estructura del error
      } else {
        setError("Ocurrió un error al enviar los datos.");
      }
    }
  };

  return (
    <ModalForm
      title="Agregar un nuevo vehículo"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleFormSubmit}
      textBtn="Agregar vehículo"
    >
      {error && <p className="text-red-600 mb-4">{error}</p>}

      <div className="grid grid-cols-2 gap-4">
        <div>
          <CustomTextInput
            label="Nombre del vehículo"
            placeholder="Ingresa el nombre del vehículo"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            isRequired
          />
          {fieldErrors.name && (
            <p className="text-red-600 text-sm">{fieldErrors.name[0]}</p>
          )}
        </div>
        <div>
          <CustomTextInput
            label="Chapa del vehiculo"
            placeholder="Ingresa la chapa del vehículo"
            type="text"
            value={licensePlate}
            onChange={(e) => setLicensePlate(e.target.value)}
            isRequired
          />
          {fieldErrors.licensePlate && (
            <p className="text-red-600 text-sm">
              {fieldErrors.licensePlate[0]}
            </p>
          )}
        </div>
        <div>
          <CustomTextInput
            label="Propiedad de"
            placeholder="Selecciona al propietario"
            type="select"
            value={ownership}
            onChange={(e) => setOwnership(e.target.value)}
            options={ownershipOptions}
            isRequired
          />
          {fieldErrors.ownership && (
            <p className="text-red-600 text-sm">{fieldErrors.ownership[0]}</p>
          )}
        </div>
        <div>
          <CustomTextInput
            label="Tipo de vehículo"
            placeholder="Selecciona el tipo de vehículo"
            type="select"
            value={vehicleType}
            onChange={(e) => setVehicleType(e.target.value)}
            options={vehicleTypeOptions}
            isRequired
          />
          {fieldErrors.vehicleType && (
            <p className="text-red-600 text-sm">{fieldErrors.vehicleType[0]}</p>
          )}
        </div>
        <div>
          <CustomTextInput
            label="Estado"
            placeholder="Selecciona el estado"
            type="select"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            options={statusOptions}
            isRequired
          />
          {fieldErrors.status && (
            <p className="text-red-600 text-sm">{fieldErrors.status[0]}</p>
          )}
        </div>
      </div>
    </ModalForm>
  );
}
